import React from 'react';
import { RouterProvider, useRouter } from './RouterContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Products from './components/Products';
import CrmPage from './components/CrmPage';
import WhyUs from './components/WhyUs';
import Contact from './components/Contact';
import Footer from './components/Footer';
import NexoPage from './pages/NexoPage';
import LogitraxPage from './pages/LogitraxPage';
import PrivacyPage from './pages/PrivacyPage';
import CookiesPage from './pages/CookiesPage';
import AxolotePage from './pages/AxolotePage';
import './App.css';

const AppContent: React.FC = () => {
  const { page } = useRouter();

  if (page === 'nexo') return <NexoPage />;
  if (page === 'logitrax') return <LogitraxPage />;
  if (page === 'axolote') return <AxolotePage />;
  if (page === 'privacy') return <PrivacyPage />;
  if (page === 'cookies') return <CookiesPage />;

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Products />
        <CrmPage />
        <WhyUs />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <RouterProvider>
      <AppContent />
    </RouterProvider>
  );
}

export default App;
